import { render, staticRenderFns } from "./AddInstitutionForm.vue?vue&type=template&id=e3763998&"
import script from "./AddInstitutionForm.vue?vue&type=script&lang=js&"
export * from "./AddInstitutionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports